/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

import { DatasetImportOperationStatus } from '../types/dataset/DatasetImportOperationStatus';

export const datasetImportOperationStatusColors = {
  [DatasetImportOperationStatus.Pending]: '#F8A31A',
  [DatasetImportOperationStatus.Importing]: '#1F3F6D',
  [DatasetImportOperationStatus.Successful]: '#35B44E',
  [DatasetImportOperationStatus.Aborted]: '#A2A7AE',
  [DatasetImportOperationStatus.Failure]: '#F1302F',

  __fallback: '#E2E2E2',
};
